<template>
  <v-container>
    <section v-if="formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE'">
      <v-card-title class="pa-0 pb-2" style="font-size: 1.1rem; font-weight: 600">
        <v-icon left color="green">article</v-icon>
        Documentos pré-aprovados
      </v-card-title>
      <v-divider class="mb-2" />
      <v-card
        v-if="solicitacaoPreAprovada && solicitacaoPreAprovada?.arquivos?.length"
        class="mt-6 pa-3 mb-6"
        outlined
        style="border-radius: 12px"
      >
        <v-list dense flat>
          <v-list-item
            v-for="doc in solicitacaoPreAprovada.arquivos"
            :key="doc.id"
            class="mb-2"
            style="border-radius: 8px; background: #fff; box-shadow: 0 1px 3px #0001"
          >
            <v-list-item-avatar>
              <v-icon :color="doc.aprovado ? 'green' : 'red'">
                {{ doc.aprovado ? 'check_circle' : 'alert_circle' }}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title style="font-size: 0.95em; font-weight: 500">{{
                formatTitleDoc(doc.tipoDocumento)?.descricao
              }}</v-list-item-title>
              <v-list-item-subtitle style="font-size: 0.85em">
                <!-- <span style="color: #888">ID:</span> {{ doc.id }} -->
                <span style="color: #888">Situação:</span>
                <span :style="{ color: doc.aprovado ? 'green' : 'red', fontWeight: 'bold' }">
                  {{ doc.aprovado ? 'Aprovado' : 'Pendente' }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </section>
    <v-card-title
      v-if="formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE'"
      class="pa-0 pb-2 mt-5"
      style="font-size: 1.1rem; font-weight: 600"
    >
      <v-icon left color="primary">article</v-icon> Documentos pendentes
    </v-card-title>
    <v-divider class="mb-5" />
    <v-alert dense text type="warning" class="mb-4">
      Todos os documentos são obrigatórios.
    </v-alert>
    <v-alert dense text type="info" class="mb-8">
      Caso o documento exija assinatura digital, orientamos o uso da plataforma Gov.br.
    </v-alert>
    <UploadFile
      v-for="doc in orderedDocumentacao"
      :descricao="doc.descricao"
      :regraNumber="doc.regra"
      :key="doc.descricao"
      :listaDocumentos="doc.documentos"
      :requiredDoc="doc.requer"
      :fileName="filename"
      @recuperarFileName="recuperarFileName"
    />
    <section class="d-flex justify-md-start justify-center align-center">
      <vue-recaptcha
        ref="recaptcha"
        :sitekey="siteKey"
        :load-recaptcha-script="true"
        class="mb-4"
        @verify="verifyRecaptcha"
        @expired="expiredRecaptcha"
      />
    </section>
    <!-- Lista de documentos enviados -->
  </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import UploadFile from './UploadFile.vue';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'StepDoisDocumentacao',
  components: {
    VueRecaptcha,
    UploadFile,
  },
  props: {
    documentos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filename: 'Nenhum arquivo selecionado',
      siteKey: VUE_APP_RECAPTCHA_KEY,
      formaTitleDocs: [],
    };
  },
  computed: {
    ...mapState('spgc', [
      'recaptcha',
      'formSolicitacao',
      'documentacaoPorTipoSolicitacao',
      'solicitacaoPreAprovada',
      'documentosPorRegra',
    ]),
    orderedDocumentacao() {
      if (!this.documentacaoPorTipoSolicitacao[0]?.regras) return [];

      const regras = [...this.documentacaoPorTipoSolicitacao[0].regras];

      // Ordenar para que REQUERIMENTO_MERCADO_LIVRE_GAS seja sempre o primeiro
      return regras.sort((a, b) => {
        const hasRequerimentoA = a.documentos?.some(
          doc => doc.codigo === 'REQUERIMENTO_MERCADO_LIVRE_GAS'
        );
        const hasRequerimentoB = b.documentos?.some(
          doc => doc.codigo === 'REQUERIMENTO_MERCADO_LIVRE_GAS'
        );

        if (hasRequerimentoA && !hasRequerimentoB) return -1;
        if (!hasRequerimentoA && hasRequerimentoB) return 1;
        return 0;
      });
    },
  },
  watch: {
    solicitacaoPreAprovada: {
      handler(newValue) {
        this.formaTitleDocs = this.documentosPorRegra
          .filter(doc => doc.tipoSolicitacao === this.solicitacaoPreAprovada.tipoSolicitacao)
          // Extrai todas as regras -> documentos
          .flatMap(doc => doc.regras.flatMap(regra => regra.documentos));
      },
      deep: true,
    },
  },
  methods: {
    recuperarFileName(nome) {
      this.filename = nome;
    },
    verifyRecaptcha(value) {
      this.setRecaptcha(value);
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.setRecaptcha(null);
    },
    formatarTextDocument(document) {
      if (!document || !document) return '';
      // Transforma CONSUMIDOR_LIVRE em Consumidor Livre
      return document
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(^|\s)\S/g, l => l.toUpperCase());
    },
    formatTitleDoc(tipoDocumento) {
      if (this.formaTitleDocs) {
        return this.formaTitleDocs.filter(doc => doc.codigo == tipoDocumento)[0];
      }
    },
    ...mapActions('spgc', ['setRecaptcha']),
  },
  mounted() {
    // Filtra os docs pela solicitação
  },
};
</script>
